export default function FormatCurrency({value, empty='' }){
    return (value || value === 0) ? `$${value.toLocaleString("en-US", {minimumFractionDigits: 2})}` : empty
}